<template>
  <div class="wrapper-secondary">
    <HeaderMatch
      :id="id"
      :league="league"
      :is-favorite="isFavorite"
      :mini="mini"
      :status="match.timeStatus"
      :permision="permision"
      @favorite="() => $emit('favorite')"
      @view="() => $emit('view')"
    />
    <div class="match-body">
      <div class="header">
        <div class="team">
          <h2>{{ home.name }}</h2>
          <div
            class="cards"
            style="display: flex; gap: 10px; align-items: center"
          >
            <span v-if="home.redCard" class="red-card">{{ home.redCard }}</span>
            <span v-if="homeYellowCards" class="yellow-card">{{
              home.yellowCards
            }}</span>
            <WinCoef class="cofficient" :value="companyData.homeWinCoef" />
          </div>
        </div>
        <div class="info">
          <div class="block"></div>
          <div>
            <ScoreInfo
              :id="id"
              :time="time"
              :home-score="home.score"
              :away-score="away.score"
              :is-away-goal="isAwayGoal"
              :is-away-no-goal="isAwayNoGoal"
              :is-home-no-goal="isHomeNoGoal"
              :is-home-goal="isHomeGoal"
              :first-time="match.firstTime"
              :ended="match.ended"
            />
            <StatsInfo v-if="matchIndexes" :match-indexes="matchIndexes" />
          </div>
          <div class="block"></div>
        </div>
        <div class="team">
          <div
            class="cards"
            style="display: flex; gap: 10px; align-items: center"
          >
            <WinCoef class="cofficient" :value="companyData.awayWinCoef" />
            <span v-if="away.redCard" class="red-card">{{ away.redCard }}</span>
            <span v-if="away.yellowCards" class="yellow-card">{{
              away.yellowCards
            }}</span>
          </div>
          <h2>{{ away.name }}</h2>
        </div>
      </div>
      <div class="stats-info-mobile-wrapp">
        <StatsInfo v-if="matchIndexes" :match-indexes="matchIndexes" />
        <div class="stats-info-mobile">
          <div class="score">
            <ScoreInfo
              :id="id"
              :time="time"
              :home-score="home.score"
              :away-score="away.score"
              :is-away-goal="isAwayGoal"
              :is-away-no-goal="isAwayNoGoal"
              :is-home-no-goal="isHomeNoGoal"
              :is-home-goal="isHomeGoal"
              :first-time="match.firstTime"
              :ended="match.ended"
            />
          </div>
          <div style="display: flex; flex-direction: column; width: 100%">
            <div class="info-wrap">
              <div>
                <div class="info">
                  <div class="info-header">
                    <p>{{ home.name }}</p>
                    <span v-if="home.redCard" class="red-card">{{
                      home.redCard
                    }}</span>
                    <span v-if="home.yellowCards" class="yellow-card">{{
                      home.yellowCards
                    }}</span>
                    <WinCoef
                      class="cofficient"
                      :value="companyData.homeWinCoef"
                    />
                  </div>
                  <div class="info-body" />
                </div>
              </div>
            </div>

            <div class="info-wrap">
              <div>
                <div class="info">
                  <div class="info-header">
                    <p>{{ away.name }}</p>
                    <span v-if="away.redCard" class="red-card">{{
                      away.redCard
                    }}</span>
                    <span v-if="away.yellowCards" class="yellow-card">{{
                      away.yellowCards
                    }}</span>
                    <WinCoef
                      class="cofficient"
                      :value="companyData.awayWinCoef"
                    />
                  </div>
                  <div class="info-body" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MatchFooter v-if="filtered.status" :filtered='filtered'/>
      <div v-show="!mini" class="tables">
        <div class="wrap">
          <div class="table">
            <h2 class="top">
              TOTAL ALERTS <span>({{ signalHistory.total.length }})</span>
            </h2>
            <div v-if="signalHistory.total.length" class="bottom">
              <div
                v-for="(title, key) of tableFields.totalMinSig"
                :key="title"
                class="item"
              >
                <span>{{ title }}</span>
                <span
                  v-for="(item, index) of signalHistory.total"
                  :key="index"
                  class="capitalize"
                  :class="[item.$partClass]"
                >
                  {{
                    item[key] || item[key] === 0 ? shortWord(item[key]) : "-"
                  }}
                </span>
              </div>
            </div>
            <div v-else class="bottom">
              <p class="no-data">No Data</p>
            </div>
          </div>
          <div class="table">
            <h2 class="top">
              TOTAL HT <span>({{ companyData.HTCount }})</span>
            </h2>
            <div
              v-if="companyData.HT.length"
              class="bottom"
              style="width: 100%"
            >
              <div
                v-for="(title, key) of tableFields.total"
                :key="title"
                class="item"
              >
                <span>{{ title }}</span>
                <template v-for="(item, index) of companyData.HT">
                  <TradeDynamicCell
                    v-if="key == 'over' && item.diff"
                    :key="`over-${index}`"
                    :value="item[key]"
                    :rate-value="item.diff"
                    is-show-rate
                  />
                  <TradeDynamicCell
                    v-else-if="key == 'under' && item.diff"
                    :key="`under-${index}`"
                    :value="item[key]"
                    :rate-value="item.diff * -1"
                    is-show-rate
                  />
                  <TradeDynamicCell
                    v-else-if="key == 'total' && item.diff"
                    :key="`total-${index}`"
                    :value="item[key]"
                    :rate-value="item.totalDiff"
                    is-show-rate
                  />
                  <span v-else :key="index">{{
                    item[key] ? item[key] : "-"
                  }}</span>
                </template>
              </div>
            </div>
            <div v-else class="bottom">
              <p class="no-data">No Data</p>
            </div>
          </div>
          <div class="table">
            <div class="top">
              TOTAL FT <span>({{ companyData.FTCount }})</span>
            </div>
            <div class="bottom">
              <div
                v-for="(title, key) of tableFields.total"
                :key="title"
                class="item"
              >
                <span>{{ title }}</span>
                <template v-for="(item, index) of companyData.FT">
                  <TradeDynamicCell
                    v-if="key == 'over' && item.diff"
                    :key="`over-${index}`"
                    :value="item[key]"
                    :rate-value="item.diff"
                    is-show-rate
                    is-big
                  />
                  <TradeDynamicCell
                    v-else-if="key == 'under' && item.diff"
                    :key="`under-${index}`"
                    :value="item[key]"
                    :rate-value="item.diff * -1"
                    is-show-rate
                    is-big
                  />
                  <TradeDynamicCell
                    v-else-if="key == 'total' && item.diff"
                    :key="`total-${index}`"
                    :value="item[key]"
                    :rate-value="item.totalDiff"
                    is-show-rate
                  />
                  <span v-else :key="index">{{
                    item[key] ? item[key] : "-"
                  }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="block"></div>
        <div class="wrap">
          <div class="table">
            <h2 class="top">
              HDP ALERTS <span>({{ signalHistory.hdp.length }})</span>
            </h2>
            <div v-if="signalHistory.hdp.length" class="bottom">
              <div
                v-for="(title, key) of tableFields.hdpMinSig"
                :key="title"
                class="item"
              >
                <span>{{ title }}</span>
                <span
                  v-for="(item, index) of signalHistory.hdp"
                  :key="index"
                  class="capitalize"
                  :class="[item.$partClass]"
                >
                  {{
                    item[key] || item[key] === 0 ? shortWord(item[key]) : "-"
                  }}
                </span>
              </div>
            </div>
            <div v-else class="bottom">
              <p class="no-data">No Data</p>
            </div>
          </div>
          <div class="table">
            <h2 class="top">
              HDP HT <span>({{ companyData.HThdpCount }})</span>
            </h2>
            <div v-if="companyData.HThdp.length" class="bottom">
              <div
                v-for="(title, key) of tableFields.hdp"
                :key="title"
                class="item"
              >
                <span>{{ title }}</span>
                <template v-for="(item, index) of companyData.HThdp">
                  <TradeDynamicCell
                    v-if="key == 'over' && item.diff"
                    :key="`over-${index}`"
                    :value="item[key]"
                    :rate-value="item.diff"
                    is-show-rate
                  />
                  <TradeDynamicCell
                    v-else-if="key == 'under' && item.diff"
                    :key="`under-${index}`"
                    :value="item[key]"
                    :rate-value="item.diff * -1"
                    is-show-rate
                  />
                  <TradeDynamicCell
                    v-else-if="key == 'total' && item.diff"
                    :key="`total-${index}`"
                    :value="item[key]"
                    :rate-value="item.totalDiff"
                    is-show-rate
                  />
                  <span v-else :key="index">{{
                    Number.isNaN(item[key]) || item[key] == null
                      ? "-"
                      : item[key]
                  }}</span>
                </template>
              </div>
            </div>
            <div v-else class="bottom">
              <p class="no-data">No Data</p>
            </div>
          </div>
          <div class="table">
            <div class="top">
              HDP FT <span>({{ companyData.FThdpCount }})</span>
            </div>
            <div class="bottom">
              <div
                v-for="(title, key) of tableFields.hdp"
                :key="title"
                class="item"
              >
                <span>{{ title }}</span>
                <template v-for="(item, index) of companyData.FThdp">
                  <TradeDynamicCell
                    v-if="key == 'over' && item.diff"
                    :key="`over-${index}`"
                    :value="item[key]"
                    :rate-value="item.diff"
                    is-show-rate
                    is-big
                  />
                  <TradeDynamicCell
                    v-else-if="key == 'under' && item.diff"
                    :key="`under-${index}`"
                    :value="item[key]"
                    :rate-value="item.diff * -1"
                    is-show-rate
                    is-big
                  />
                  <TradeDynamicCell
                    v-else-if="key == 'total' && item.diff"
                    :key="`total-${index}`"
                    :value="item[key]"
                    :rate-value="item.totalDiff"
                    is-show-rate
                  />
                  <span v-else :key="index">{{
                    !Number.isNaN(item[key]) && item[key] !== null
                      ? item[key]
                      : "-"
                  }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MatchUtil } from "@/store/utils";
import TradeDynamicCell from "./common/TradeDynamicCell.vue";
import ScoreInfo from "./common/ScoreInfo.vue";
import StatsInfo from "./common/StatsInfo.vue";
import HeaderMatch from "./common/HeaderMatch.vue";
import WinCoef from "./common/WinCoef.vue";
import MatchFooter from './common/MatchFooter.vue';

const { MATCH_PART_KEYS, MatchList } = MatchUtil;
const { MATCH_FILTER_KEYS } = MatchList;

const TICKER_SIGNAL_KEYS = {
  CS: "CS",
  HS: "HS",
};

const defaultCompanyData = {
  companyId: 0,
  homeWinCoef: 0,
  awayWinCoef: 0,
  HThdp: [],
  FThdp: [],
  HT: [],
  FT: [],
};

export default {
  name: "TickerMatch",
  components: {
    TradeDynamicCell,
    ScoreInfo,
    StatsInfo,
    HeaderMatch,
    WinCoef,
    MatchFooter,
  },
  props: {
    id: Number,
    data: Array,
    historySignal: Array,
    filtered: Object,
    awayName: String,
    awayRedCards: Number,
    awayScore: Number,
    awayYellowCards: Number,
    awayScoreChanged: Boolean,
    homeName: String,
    homeRedCards: Number,
    homeScore: Number,
    homeYellowCards: Number,
    homeScoreChanged: Boolean,
    league: String,
    time: Number,
    mini: Boolean,
    isFavorite: Boolean,
    match: Object,
    home: Object,
    away: Object,
    permision: String,
    // CSS Classes
    timeLevelClass: String,
  },
  data() {
    return {
      tableFields: {
        totalMinSig: {
          time: "Minute",
          score: "Score",
          type: "Type",
          title: "Market",
          odds: "Odds",
        },
        totalSig: {
          time: "Time",
          score: "Score",
          type: "Type",
          market: "Market",
          total: "Total",
          odds: "Odds",
        },
        total: {
          time: "Time",
          score: "Score",
          over: "Over",
          total: "Total",
          under: "Under",
        },
        hdpMinSig: {
          time: "Minute",
          score: "Score",
          type: "Type",
          title: "Market",
          odds: "Odds",
        },
        hdpSig: {
          time: "Time",
          score: "Score",
          type: "Type",
          market: "Market",
          total: "Hdp",
          odds: "Odds",
        },
        hdp: {
          time: "Time",
          score: "Score",
          over: "Home",
          total: "Hdp",
          under: "Away",
        },
      },
      companyId: 8,
    };
  },
  computed: {
    isHomeGoal() {
      return this.home.lastGoal
        ? new Date().getTime() - this.home.lastGoal < 60 * 1000
        : false;
    },
    isAwayGoal() {
      return this.away.lastGoal
        ? new Date().getTime() - this.away.lastGoal < 60 * 1000
        : false;
    },
    isHomeNoGoal() {
      return this.home.lastNoGoal
        ? new Date().getTime() - this.home.lastNoGoal < 60 * 1000
        : false;
    },
    isAwayNoGoal() {
      return this.away.lastNoGoal
        ? new Date().getTime() - this.away.lastNoGoal < 60 * 1000
        : false;
    },
    companies() {
      if (!this.companyDataMap) return [];
      return {}.filter((row) => this.companyDataMap[row.id]);
    },
    companyDataMap() {
      return this.data.reduce(
        (acc, data) => ({ ...acc, [data.companyId]: data }),
        {},
      );
    },
    companyData() {
      const result =
        this.companyDataMap[this.companyId] ||
        this.data[0] ||
        defaultCompanyData;

      Object.keys(defaultCompanyData).forEach((key) => {
        if (!(key in result)) result[key] = defaultCompanyData[key];
      });
      return this.processOdds(result);
    },
    companySignalMap() {
      return this.historySignal.reduce(
        (acc, data) => ({
          ...acc,
          [data.companyId]: (acc[data.companyId] || []).concat(data),
        }),
        {},
      );
    },
    companySignals() {
      return this.companySignalMap[this.companyId] || [];
    },

    signalHistory() {
      const isMobile = window.innerWidth < 600;
      const test = this.companySignals.reduce(
        (acc, row) => {
          const key = row.oddsType || "total";

          row.title = isMobile
            ? `${row.part == "HT" ? "HT" : "FT"} ${row.market} ${row.total}`
            : `${row.part == "HT" ? "Half Time" : "Full Time"} ${row.market} ${row.total}`;
          return {
            ...acc,
            [key]: [...acc[key]].concat(row),
          };
        },
        { total: [], hdp: [] },
      );
      return test;
    },

    companyIdFilter: {
      get() {
        const { value } = this.$store.state.match.filters.find(
          (filter) =>
            typeof filter === "object" &&
            filter.type === MATCH_FILTER_KEYS.COMPANY,
        );
        return value;
      },
    },
    matchIndexes() {
      const signalMap = {
        [TICKER_SIGNAL_KEYS.CS]: this.companySignals,
        [TICKER_SIGNAL_KEYS.HS]: this.historySignal,
      };

      const signalIndexes = Object.keys(signalMap).reduce(
        (acc, key) => ({ ...acc, [key]: acc[key] + signalMap[key].length }),
        { [TICKER_SIGNAL_KEYS.CS]: 0, [TICKER_SIGNAL_KEYS.HS]: 0 },
      );

      const partIndexes = this.companySignals.reduce(
        (acc, { part }) => ({ ...acc, [part]: acc[part] + 1 }),
        { [MATCH_PART_KEYS.HT]: 0, [MATCH_PART_KEYS.FT]: 0 },
      );

      return {
        signals: signalIndexes,
        parts: partIndexes,
      };
    },
  },
  watch: {
    companyData() {
      if (this.companyData && this.companyData.companyId && !this.companyId) {
        this.companyId = +this.companyData.companyId;
      }
    },
    companyIdFilter() {
      this.selectCompany();
    },
  },
  mounted() {
    if (this.companyId === null && this.companies.length) {
      this.selectCompany();
    }
  },
  methods: {
    processOdds(odds) {
      const keys = ["HThdp", "FThdp", "HT", "FT"];
      const result = { ...odds };

      for (const key of keys) {
        if (key in odds) {
          result[key] = odds[key]
            .map((item, index) => {
              const prev =
                odds[key][index + 1]?.over !== undefined
                  ? odds[key][index + 1]
                  : odds[key][index + 2];

              return {
                ...item,
                totalDiff:
                  prev && item.over !== null ? item.total - prev.total : 0,
                diff: prev && item.over !== null ? item.over - prev.over : 0,
              };
            })
            .slice(0, 3);
        }
      }

      return result;
    },
    getCompanyData(companyId) {
      return {};
    },
    selectCompany() {
      console.log(companyIdFilter);
      const companyId = this.companyIdFilter;
      const firstCompany = this.companies[0];
      const filterCompany = this.companies.find(({ id }) => id === companyId);
      this.companyId = (filterCompany || firstCompany).id;
    },
    shortWord(value) {
      switch (value) {
        case "highTrended":
          return "high";
        case "lowTrended":
          return "low";
        default:
          return value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-secondary {
  margin-bottom: 28px;
  padding: 0;
}

.match-body {
  display: flex;
  flex-direction: column;
  background-color: var(--league-body-color);
  border-radius: 0 0 26px 26px;
  width: 100%;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 40px 20px 40px !important;

    .team {
      display: flex;
      align-items: center;
      gap: 10px;

      .cards {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .yellow-card {
        background-color: #ffe500;
        padding: 5px 10px 5px 10px;
        width: 28px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        color: #151515;
        font-weight: 400;
        font-size: 12px;
        line-height: 14.52px;
      }

      .red-card {
        background-color: var(--danger-color);
        padding: 5px 10px 5px 10px;
        width: 26px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        color: white;
        font-weight: 400;
        font-size: 12px;
        line-height: 14.52px;
      }

      h2 {
        line-height: 19.86px;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0.02em;
        color: var(--font-colorF);
      }

      span {
        font-weight: 400;
        font-size: 16px;
        line-height: 19.84px;
        letter-spacing: 0.02em;
      }
    }

    .info {
      display: flex;
      align-items: center;
      gap: 50px;

      .block {
        background-color: var(--match-border-color);
        height: 80px;
        width: 1px;
        margin: 0;
      }
    }
  }

  .tables {
    display: flex;
    justify-content: space-evenly;
    padding: 20px 5px;
    border-top: 1px solid var(--match-border-color);
    width: 100%;

    .block {
      margin: auto 5px;
      height: 80px;
      width: 1px;
      border-radius: 10px;
      background-color: #c5c5c5;
    }

    .wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      max-width: 485px;
    }

    .no-data {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 24.55px;
      font-weight: 400;
      font-size: 12px;
      line-height: 14.88px;
      letter-spacing: 0.02em;
      opacity: 0.5;
      color: var(--font-color);
      text-align: center;
      width: 100%;
      border-top: 1px solid #cbcbcb;
    }

    .table {
      display: flex;
      flex-direction: column;
      background-color: var(--shots-body-color);
      width: 100%;
      max-width: 380px;
      overflow: hidden;
      margin-top: 6px;
      border-radius: 16px;
      border: solid 1px var(--font-color);

      .top {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 3px;
        padding: 10px;
        font-weight: 400;
        font-size: 18px;
        line-height: 19.84px;
        letter-spacing: 0.02em;

        span {
          color: #b3b3b3;
        }
      }

      .bottom {
        width: 100%;
        display: flex;
        align-items: center;

        .item {
          width: 100%;
          white-space: nowrap;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .no-data {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            min-height: 24.55px;
            font-weight: 400;
            font-size: 12px;
            line-height: 14.88px;
            letter-spacing: 0.02em;
            opacity: 0.5;
            color: var(--font-color);
            border-top: 1px solid #cbcbcb;
            border-right: 1px solid #cbcbcb;
          }

          span {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            border-top: 1px solid #cbcbcb;
            border-right: 1px solid #cbcbcb;
            height: 35px;
            padding: 5px;
          }

          &:last-child {
            span {
              border-right: none;
            }
          }
        }
      }
    }
  }

  .tag {
    cursor: pointer;
    user-select: none;
    padding: 8px 16px 8px 16px;
    border: 1px solid var(--font-color);
    background-color: transparent;
    border-radius: 100px;
    color: var(--font-color);
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 400;

    span {
      color: #b3b3b3;
      font-weight: 700;
      line-height: 15.02px;
      padding-left: 9px;
      font-size: 10px;
    }
  }

  .tag-select {
    select {
      cursor: pointer;
      user-select: none;
      outline: none;
      border: none;
      background-color: transparent;
      color: var(--font-color);
    }
  }

  .info {
    display: flex;

    .info-header {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-wrap: wrap;

      .yellow-card {
        background-color: #ffe500;
        padding: 5px 10px 5px 10px;
        width: 28px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        color: var(--font-color);
        font-weight: 400;
        font-size: 12px;
        line-height: 14.52px;
      }

      .red-card {
        background-color: var(--danger-color);
        padding: 5px 10px 5px 10px;
        width: 26px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        color: white;
        font-weight: 400;
        font-size: 12px;
        line-height: 14.52px;
      }

      .rate {
        font-weight: 400;
        font-size: 16px;
        line-height: 19.84px;
        letter-spacing: 0.02em;
      }

      p {
        font-weight: 500;
        font-size: 16px;
        line-height: 19.86px;
        color: var(--font-color);
      }
    }

    .last {
      justify-content: end;
    }

    .info-body {
      display: flex;
      align-items: center;
      gap: 6px;
      padding-top: 22px;
      color: var(--shots-body-color);
      flex-wrap: wrap;

      .info-item {
        display: flex;
        align-items: center;
        gap: 9px;
        padding: 6px 12px 6px 12px;
        border-radius: 100px;
        font-weight: 700;
        font-size: 12px;
        line-height: 15.02px;
      }

      .shots {
        color: var(--shots-color);
        background-color: var(--shots-body-color) !important;
      }
    }
  }

  .stats-info-mobile-wrapp {
    display: none;
    flex-direction: column;
    align-items: center;
  }

  .stats-info-mobile {
    .info {
      flex-direction: column;
    }
  }

  .score {
    display: flex;
    align-items: center;
    gap: 92px;
  }

  .stats-info-mobile {
    display: none;
    // align-items: center;
    padding: 20px 40px 20px 40px;
    width: 100%;
    gap: 30px;
    height: 100%;

    .block {
      width: 10px;
      border-radius: 10px;
      height: auto;
      margin-bottom: 0;
    }

    .score {
      width: 100%;
      // height: 100%;
    }

    .info-wrap {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      width: 100%;
      gap: 20px;
      height: 100%;

      .block {
        background-color: #c5c5c5;
      }
    }
  }

  .stats-info-mobile .info-wrap:first-child {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e1e1e1;
  }
}

@media screen and (max-width: ($desktop + 1)) {
  .match-body {
    .team {
      flex-direction: column;
    }

    .tables {
      flex-direction: column;
      align-items: center;

      .block {
        display: none;
      }
    }

    .tables .wrap:last-child {
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #c5c5c5;
    }
  }

  .match-body .team:last-child {
    flex-direction: column-reverse;
  }
}

@media screen and (min-width: $tablet) and (max-width: $desktop) {
  .match-body {
    .tables {
      gap: 10px;

      .wrap {
        // .table {
        //   max-width: 360px;
        // }

        .block {
          display: none;
        }
      }
    }

    .header {
      .info {
        gap: 16px;
      }
    }
  }
}

@media screen and (max-width: $tablet) {
  .match-body {
    .stats-info-mobile-wrapp {
      display: flex;
    }

    .header {
      display: none;
    }

    .stats-info-mobile {
      display: flex;

      .info-header {
        p {
          font-weight: 700;
        }
      }
    }
  }
}

@media screen and (max-width: $mobile) {
  .match-body {
    .stats-info-mobile {
      align-items: normal;
      padding: 20px !important;
      gap: 10px;

      .score {
        width: max-content;
        height: auto;
      }

      .info-wrap {
        align-items: normal;

        .block {
          height: auto;
        }
      }
    }

    .tables {
      .wrap {
        justify-items: auto;

        .table {
          max-width: 360px;
        }

        .block {
          display: none;
        }
      }
    }
  }
}

.match-type .match-odds {
  text-transform: capitalize;
}

.match-odds {
  padding: 3px 5px;
  border-radius: 10px;
}

.capitalize {
  text-transform: capitalize;
}
</style>
